import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'key' })
export class KeyPipe implements PipeTransform {
  transform(data: any): string {
    return data.key.substr(0, 8);
  }
}
